import { useEffect, useState } from"react";

const SECTIONS = [
 { id:"free-trial-section", label:"Free Trial" },
 { id:"features", label:"Features" },
 { id:"how-it-works", label:"How It Works" },
 { id:"pricing", label:"Pricing" },
];

export const ScrollProgressBar = () => {
 const [progress, setProgress] = useState(0);
 const [visible, setVisible] = useState(false);
 const [activeSection, setActiveSection] = useState("");

 useEffect(() => {
 const handleScroll = () => {
 const docHeight = Math.max(
 document.body.scrollHeight - window.innerHeight,
 1
 );
 const scrollPct = Math.min((window.scrollY / docHeight) * 100, 100);
 setProgress(scrollPct);
 setVisible(window.scrollY > 300);

 // Determine active section
 for (let i = SECTIONS.length - 1; i >= 0; i--) {
 const el = document.getElementById(SECTIONS[i].id);
 if (el && el.getBoundingClientRect().top <= 150) {
 setActiveSection(SECTIONS[i].id);
 break;
 }
 }
 };

 window.addEventListener("scroll", handleScroll, { passive: true });
 return () => window.removeEventListener("scroll", handleScroll);
 }, []);

 if (!visible) return null;

 return (
 <div className="fixed top-0 left-0 right-0 z-50">
 {/* Progress bar */}
 <div className="h-0.5 bg-border/30">
 <div
 className="h-full bg-primary transition-[width] duration-150 ease-out"
 style={{ width: `${progress}%` }}
 />
 </div>
 {/* Section nav pills */}
 <div className="absolute top-2 left-1/2 -translate-x-1/2 hidden lg:flex items-center gap-1 rounded-full border border-border bg-background px-2 py-1">
 {SECTIONS.map((s) => (
 <button
 key={s.id}
 onClick={() =>
 document.getElementById(s.id)?.scrollIntoView({ behavior:"smooth" })
 }
 className={`px-3 py-1 rounded-full text-xs font-medium transition-colors ${
 activeSection === s.id
 ?"bg-primary text-primary-foreground"
 :"text-muted-foreground hover:text-foreground"
 }`}
 >
 {s.label}
 </button>
 ))}
 </div>
 </div>
 );
};
